<script>
import { diffkyesLambdaInvoke } from '../../utils/LambdaHelper'
export default {
  data () {
    return {
      diffKeys: []
    }
  },
  mounted () {
    try {
      diffkyesLambdaInvoke().then(res => {
        this.diffKeys = res.diff_keys || []
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    showChangeIcon (keyList) {
      for (let key of keyList) {
        if (this.diffKeys.indexOf(key) > -1) {
          return true
        }
      }
      return false
    },
    isChangeNotice (key) {
      return this.diffKeys.indexOf(key) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixin/ChangeIcon.vue